import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
@Component({
  selector: 'app-word-plugin',
  templateUrl: './word-plugin.component.html',
  styleUrls: ['./word-plugin.component.scss']
})
export class wordpluginComponent implements OnInit {

  downloadLink: string = '';
  downloadLink1: string = '';

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('免費 MS Word 文法檢查外掛｜Trinka MS Word 擴充工具');
    this.metaTagService.updateTag({ name: 'description', content: '直接在熟悉的 Word 介面中使用 Trinka 的文法檢查外掛，寫作同時即時收到專業文法修正與用詞建議，提升語言品質不再費力。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '高級文法檢查，拼寫檢查工具，免費文法檢查，學術寫作助手' });
    this.metaTagService.updateTag({ property: 'og:title', content: '免費 MS Word 文法檢查外掛｜Trinka MS Word 擴充工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: '直接在熟悉的 Word 介面中使用 Trinka 的文法檢查外掛，寫作同時即時收到專業文法修正與用詞建議，提升語言品質不再費力。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/wordplugin' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-tw' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/wordplugin' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/wordplugin' });
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      this.setDownloadLink();
    }
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  
  setDownloadLink(): void {
    if (navigator.userAgent.indexOf("WOW64") != -1 || navigator.userAgent.indexOf("Win64") != -1) {
      this.downloadLink = '<a class="filled-btn" href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank"><img src="/assets/images/icons/download.svg" alt="whitepaper"> Download Now</a>';
      this.downloadLink1 = '<a href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank" class="text-link">Download Now</a>';
    } else {
      this.downloadLink = '<a class="filled-btn" href="https://s3.amazonaws.com/trinka-word-plugin/32bit/Trinka.Installer.msi" target="_blank"><img src="/assets/images/icons/download.svg" alt="whitepaper"> Download Now</a>';
      this.downloadLink1 = '<a href="https://s3.amazonaws.com/trinka-word-plugin/32bit/Trinka.Installer.msi" target="_blank" class="text-link">Download Now</a>';
    }
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
